// AUTO-GENERATED by scripts/site/build-site.mjs — elle düzenlemeyin; kaynak: src/content/{audiences,features,guides,authors}/*.md
// Küçük dizin: rotalar, alt bilgi ve lansman bunu import eder. Sayfa metinleri pages/*.generated.ts'te.
import type { ContentIndex } from './content-types';

export const CONTENT_INDEX: ContentIndex = {
  "mode": "production",
  "audiences": [],
  "features": [],
  "guides": [],
  "authors": [],
  "featureIndex": null,
  "guideIndex": null,
  "rss": false
};
